import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// AG Grid
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
// import { AgGridModule } from 'ag-grid-angular';

// Register AG Grid modules (Community or Enterprise)
ModuleRegistry.registerModules([AllCommunityModule]);

// Set global grid options (⚠️ this returns void, do not include in providers)
provideGlobalGridOptions({
  suppressCellFocus: true,
  suppressHorizontalScroll: false,
  rowSelection: 'multiple',
  // ⚠️ Only "legacy" is supported here as per AG Grid docs for global config
  theme: 'legacy',
});

// Icons
import { addIcons } from 'ionicons';
import {
  downloadOutline,
  helpCircleOutline,
  powerOutline,
  reloadOutline,
  settingsOutline,
  closeCircle,
  closeOutline,
  documentOutline,
  trashOutline,
  albumsOutline,
  addCircleOutline,
  removeCircleOutline,
  cloudUploadOutline,
  mailOutline,
  keyOutline,
  logoGoogle
} from 'ionicons/icons';

addIcons({
  'help-circle-outline': helpCircleOutline,
  'power-outline': powerOutline,
  'download-outline': downloadOutline,
  'reload-outline': reloadOutline,
  'settings-outline': settingsOutline,
  'close-circle': closeCircle,
  'close-outline': closeOutline,
  'document-outline':documentOutline,
  'trash-outline':trashOutline,
  'albums-outline':albumsOutline,
  'add-circle-outline':addCircleOutline,
  'remove-circle-outline':removeCircleOutline,
  'cloud-upload-outline':cloudUploadOutline,
  'mail-outline':mailOutline,
  'key-outline':keyOutline,
  'logo-google':logoGoogle
});

// Start the app
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
